import ZeroUserData from '@newspaces/zero-base/models/UserData';
import Model from '@newspaces/zero-base/Model';

class UserData extends ZeroUserData {
  static Fields = {};
  constructor(data) {
    super(UserData.Fields, data);
  }
}
Model.declareModel(UserData);

export { UserData as default };
//# sourceMappingURL=UserData.js.map
